@if (riskScore) {
  <div class="dropdown">
    <div
      class="dropdown-togglable"
      (click)="toggle()"
      (keydown.space)="toggle()"
      (keydown.enter)="toggle()"
      tabindex="0"
      >
      <div class="icon-container">
        <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'width.px':18, 'transform': toggled ? 'rotate(180deg)' : '' }"></svg-icon>
      </div>
      <div class="dropdown-header">
        {{ 'newPortfolio.riskScoreHeading.' + riskScore | translate }} {{ 'newPortfolio.riskScoreHeading.suffix' | translate }}
      </div>
    </div>
    <div class="dropdown-description" [ngClass]="{ 'dropdown-description--toggled': toggled }" >
      {{ 'newPortfolio.riskScoreDescription.' + riskScore | translate }}
    </div>
  </div>
}
